export enum StateKeys {
    LensTags = "lensTags",
    SpectaclesTags = "spectaclesTags",
    Visibility = "visibility",
    LensCta = "lensCta",
    IsGameUserProvided = "isGameUserProvided",
    PrimaryCategory = "primaryCategory",
    SecondaryCategory = "secondaryCategory",
    DigitalGoods = "digitalGoods",
    SessionId = "sessionId",
    BlizzardInitialized = "blizzardInitialized",
    Discoverability = "discoverability",
    LensCreatorPayoutEnrolled = "lensCreatorPayoutEnrolled",
    LensDescription = "lensDescription",
    ReleaseNote = "releaseNote",
    LensPreviewMediaItems = "lensPreviewMediaItems",
    SurfaceType = "surfaceType",
}
